var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" "+_vm._s(_vm.query)+" "),_c('v-col',{staticClass:"d-flex",attrs:{"cols":"12","sm":"6"}},[_c('v-radio-group',{model:{value:(_vm.radioGroup),callback:function ($$v) {_vm.radioGroup=$$v},expression:"radioGroup"}},_vm._l((this.options),function(n){return _c('v-radio',{key:n,attrs:{"label":` ${n}`,"value":n}})}),1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }